import { h } from "omi";

export function Crown() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="126" height="125" viewBox="0 0 126 125" fill="none">
      <path
        d="M15.7574 74.2948C20.4567 66.7711 26.6139 60.1627 31.953 53.1243C33.8945 50.565 35.6022 47.8827 37.3099 45.2005C38.1024 43.9763 38.7642 40.4462 39.8656 41.4724C40.7947 42.2589 40.4775 46.2684 40.5706 47.5105C40.7467 53.4199 40.0372 59.3114 39.623 65.2088C39.5437 66.2112 38.5135 70.4426 38.975 70.9834C39.7813 72.0037 44.1772 70.734 45.2469 70.4013C49.2922 68.9474 59.9186 60.362 62.3414 60.2928C63.1101 60.2492 63.629 63.8032 63.7339 64.455C64.0626 68.6547 62.6698 73.2922 61.3503 77.2225C60.8471 78.7479 60.2269 80.2118 59.3117 81.6697C59.2502 81.7866 58.6975 82.8385 58.6975 82.8385C65.7537 87.2921 75.7463 77.9263 79.215 78.705C80.2729 78.9625 79.2188 84.3746 78.9671 85.1373C78.3292 87.4868 71.7101 102.354 70.0381 103.265C66.6941 105.088 60.3689 99.5266 57.6252 97.9358C46.7181 91.1603 35.1412 85.3753 23.6813 79.6518"
        stroke="currentColor"
        stroke-width="3.57762"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M18.8436 76.9321C18.0255 76.5022 17.3856 76.0169 16.6289 75.4701"
        stroke="currentColor"
        stroke-width="3.57762"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M57.2461 23.7092C57.7769 26.6728 58.486 29.581 58.2481 32.5882"
        stroke="currentColor"
        stroke-width="3.57762"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M77.1719 31.2048C76.6627 33.0254 76.2703 34.9073 75.6443 36.6664"
        stroke="currentColor"
        stroke-width="3.57762"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M96.2903 44.2278C93.4257 45.7055 90.9176 47.0723 88.6315 49.1523"
        stroke="currentColor"
        stroke-width="3.57762"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M105.833 56.7155C103.325 58.0823 103.565 57.91 101.051 59.572"
        stroke="currentColor"
        stroke-width="3.57762"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}
